import * as general from "./general.js";
import * as listener from "./listeners.js";
import * as functions from "./functions.js";
import getInfoFromReg from "./helpers/get-info.js";
import listFacilities from "./helpers/list-facilities.js";
import listServices from "./helpers/list-services.js";
import listAvailableDays from "./helpers/list-available-days.js";
import showBodelForm from "./helpers/show-bodel-form.js";
import { caleandar } from "../plugins/calendar.js";
import "../plugins/custom-select.min.js";

const form = document.querySelector("#kobra-form");

const sticky = document.querySelector(".page__footer");
let origOffsetY = sticky.offsetTop + sticky.offsetHeight;

if (typeof window.ResizeObserver != "undefined") {
  new ResizeObserver(calculateScroll).observe(form);
}

function onScroll(e) {
  if (typeof window.ResizeObserver != "undefined") {
    window.scrollY + window.innerHeight - sticky.offsetHeight <= origOffsetY
      ? (sticky.style.position = "fixed")
      : (sticky.style.position = "relative");
  }
}
document.addEventListener("scroll", onScroll);
function calculateScroll() {
  if (typeof window.ResizeObserver != "undefined") {
    sticky.style.position = "relative";
    origOffsetY = sticky.offsetTop + sticky.offsetHeight;
    sticky.style.position = "fixed";
    onScroll();
  }
}

document.querySelector("#header").classList.add("not-fixed-mobile");

document.querySelectorAll(".page__footer__car, #open_order").forEach((item) => {
  item.addEventListener("click", (e) => {
    document.querySelector(".order_confirmation").classList.toggle("visible");
    document.querySelector(".page__footer").classList.toggle("open");
    functions.createOrderSummary();
    window.scrollTo(0, form.offsetTop - 80);
  });
});

document.querySelector("#close_order").addEventListener("click", (e) => {
  document.querySelector(".order_confirmation").classList.remove("visible");
  document.querySelector(".page__footer").classList.remove("open");
});

document.querySelectorAll(".order__item__edit").forEach((button) => {
  button.addEventListener("click", listener.editListener);
});

document.querySelectorAll(".breadcrumbs .step").forEach((button) => {
  button.addEventListener("click", listener.stepListener);
});

// Uppdaterar sidan. Hämtar nya värden från WP ifall något skulle ändras. Används för debugg-syfte. Syns endast för admin.
document.querySelectorAll("#update").forEach((button) => {
  button.addEventListener("click", (e) => {
    document.dispatchEvent(new Event("pageChange"));
  });
});

if (functions.getFromUrl("mileage")) {
  general.setMileage(functions.getFromUrl("mileage"));
}

window.addEventListener("load", function () {
  document.querySelector(".kobra-block").style.opacity = 1;

  customSelect(document.querySelector("#country-code"));
});

document.addEventListener("pageChange", (e) => {
  const pageNum = parseInt(general.getCurrentPage());

  document.querySelector("#progress_bar #bar").style.width = 100 * (pageNum / 7) + "%";
  document.querySelector(".breadcrumbs .step.step--active").classList.remove("step--active");
  document.querySelector('.breadcrumbs .step[data-step="' + pageNum + '"]').classList.add("step--active");
  if (screen.width < 600) {
    const active = document.querySelector(".breadcrumbs .step.step--active");
    document.querySelector(".breadcrumbs").scrollTo(active.offsetLeft - 10, 0);
  }
  window.scrollTo(0, form.offsetTop - 80);

  document.querySelector("#kobra-form").setAttribute("data-current-page", pageNum);
  functions.lockButtons();
  if (pageNum === 1) {
    const input = document.querySelector('#kobra-form input[name="regno"]');
    input.addEventListener("input", listener.regnoListener);
    if (input.value.length >= 6) {
      listener.regnoListener(input);
    }
  } else if (pageNum === 2) {
    document.getElementById("facilities_target").innerHTML = general.getLoader(true);
    listFacilities()
      .then((value) => {
        document.getElementById("facilities_target").innerHTML = value;
        if (document.querySelectorAll(".facilities__facility.chosen").length > 0) {
          functions.unlockButtons();
          const chosenFacility = document.querySelector(".facilities__facility.chosen");
          general.setChosenFacility(chosenFacility.dataset.fac);

          const radio = chosenFacility.querySelector('input[type="radio"]');
          if (radio.dataset.extLink) {
            functions.activateExternalLink(radio.dataset.extLink, radio.dataset.extTitle);
          }
        }
      })
      .then((value) => {
        document.querySelectorAll('input[type="radio"][name="facility"]').forEach((radio) => {
          radio.addEventListener("change", listener.facListener);
        });
      })
      .then(() => {
        if (typeof window.ResizeObserver != "undefined") {
          calculateScroll();
        }
        functions.setFocus();
      });
  } else if (pageNum === 3) {
    document.getElementById("services_target").innerHTML = general.getLoader(true);
    listServices(false)
      .then((value) => {
        document.getElementById("services_target").innerHTML = value;
        if (document.querySelectorAll(".services__service.chosen").length > 0) {
          const chosen = document.querySelector(".services__service.chosen");
          const textarea = chosen.querySelector("textarea");
          let unlock = true;
          general.setChosenService(chosen.dataset.name);

          if (textarea) {
            textarea.value = general.getMessage();
            textarea.disabled = false;
            textarea.addEventListener("input", listener.textareaListener);
            // document.addEventListener('pageChange', listener.saveTextArea);
            unlock = textarea.value !== "";
          } else {
            unlock = true;
          }

          const mileage = chosen.querySelector("#mileage");
          const serviceCode = chosen.querySelector("#code");
          if (mileage) {
            unlock = false;

            mileage.disabled = false;
            mileage.addEventListener("input", listener.mileageListener);
            mileage.value = general.getMileage();

            unlock = mileage.value !== "";

            if (serviceCode) {
              serviceCode.value = general.getServiceCode();
              serviceCode.disabled = false;
              serviceCode.addEventListener("input", listener.saveCode);
            }
          }

          if (unlock) {
            functions.unlockButtons();
          } else {
            functions.lockButtons();
          }
        }
      })
      .then((value) => {
        document.querySelectorAll('input[type="checkbox"][name="service"]').forEach((radio) => {
          radio.addEventListener("change", listener.serviceListener);
        });
      })
      .then((value) => {
        document.querySelectorAll(".services__service__top__bot .readmore").forEach((opener) => {
          opener.addEventListener("click", listener.serviceOpenerListener);
        });
      })
      .then(() => {
        if (typeof window.ResizeObserver != "undefined") {
          calculateScroll();
        }
        functions.setFocus();
      });
  } else if (pageNum === 4) {
    document.getElementById("addon_target").innerHTML = general.getLoader(true);
    listServices(true)
      .then((value) => {
        document.getElementById("addon_target").innerHTML = value;
      })
      .then(() => {
        document.querySelectorAll(".addons__wrapper .show-more").forEach((button) => {
          button.addEventListener("click", listener.showMoreAddons);
        });
      })
      .then(functions.unlockButtons())
      .then(() => {
        document.querySelectorAll('input[type="checkbox"][name="addon"]').forEach((checkbox) => {
          checkbox.addEventListener("change", listener.addonListener);
        });
      })
      .then(() => {
        Array.from(document.querySelectorAll(".addons__addon.chosen")).forEach((addon) => {
          addon.parentElement.querySelector(".show-more").click();
        });
      })
      .then(() => {
        if (typeof window.ResizeObserver != "undefined") {
          calculateScroll();
        }
        functions.setFocus();
      });
  } else if (pageNum === 5) {
    document.getElementById("calendar").innerHTML = "";
    document.getElementById("timeslot_target").innerHTML = "";
    document.querySelector(".page--5").innerHTML =
      document.querySelector(".page--5").innerHTML + general.getLoader(true);

    general.setTotalTime();

    const facility = general.getChosenFacility();

    if (facility.types.includes("bodel")) {
      document.getElementById("calendar").style.display = "none";
      document.getElementById("timeslot_target").style.display = "none";
      document.getElementById("time_disclaimer").style.display = "none";
      document.getElementById("request_date").style.display = "block";
      document.querySelector(".page--5 .loading-wrapper").remove();

      document.getElementById("date_input").addEventListener("input", listener.dateRequest);

      functions.setFocus();
    } else {
      document.getElementById("calendar").style.display = "block";
      document.getElementById("timeslot_target").style.display = "block";
      document.getElementById("time_disclaimer").style.display = "block";
      listAvailableDays()
        .then((resp) => {
          let data = JSON.parse(resp.data);
          let events = [];
          if (data.availableDates && data.availableDates.length > 0) {
            data.availableDates.forEach((date) => {
              const d = date.date.split("T")[0].split("-");
              events.push({
                Date: new Date(d[0], d[1] - 1, d[2]),
                Link: date.date,
              });
            });
            var settings = {
              Color: "#fff", // (string - color) font color of whole calendar.
              LinkColor: "#fff", // (string - color) font color of event titles.
              NavShow: true, // (bool) show navigation arrows.
              DateTimeShow: true, // (bool) show current date.
              DateTimeFormat: "mmm, yyyy", // (string - dateformat) format previously mentioned date is shown in.
              EventClick: listener.clickEvent, // (function) a function that should instantiate on the click of any event. parameters passed in via data link attribute.
              EventTargetWholeDay: true, // (bool) clicking on the whole date will trigger event action, as opposed to just clicking on the title.
            };
            const cal = caleandar(document.getElementById("calendar"), events, settings);
          } else {
            document.getElementById("calendar").innerHTML =
              "<h3>Det finns tyvärr inga tillgängliga tider som passar dina önskemål</h3>";
          }
        })
        .then((events) => {
          document.querySelector(".page--5 .loading-wrapper").remove();
          functions.setFocus();
        })
        .then(() => {
          origOffsetY = sticky.offsetTop + sticky.offsetHeight;
        });
    }
  } else if (pageNum === 6) {
    const facility = general.getChosenFacility();

    if (facility.types.includes("bodel")) {
      document.getElementById("form_target").style.display = "none";
      showBodelForm();
    } else {
      document.getElementById("bodel_target").style.display = "none";
      document.getElementById("form_target").style.display = "block";
      document.getElementById("form_target").addEventListener("submit", listener.formListener);
    }
    functions.setFocus();
  }

  if (typeof window.ResizeObserver != "undefined") {
    calculateScroll();
  }
});

functions.initNextBtn();
functions.initPrevBtn();
general.setFacilities().then((e) => {
  const curRegno = functions.getFromUrl("regno");
  const curFac = functions.getFromUrl("fac");
  const curServ = functions.getFromUrl("serv");
  const curAdd = functions.getFromUrl("add");
  const curDate = functions.getFromUrl("date");
  let car;
  let num = 1;
  let go = true;
  if (curRegno && curRegno.length >= 6) {
    getInfoFromReg(curRegno)
      .then((value) => {
        car = {
          regno: curRegno,
          brand: value.brand,
          model: value.model,
          type: value.type,
        };
        general.setInfo(car);
        num = 2;
      })
      .then((value) => {
        if (curFac && curFac !== "") {
          const selectedFac = general.getFacilities()[curFac];
          if (
            selectedFac &&
            selectedFac.types.includes(car.type) &&
            selectedFac.brands.join().toLowerCase().includes(car.brand.toLowerCase())
          ) {
            general.setChosenFacility(curFac);
            num = 3;
          } else {
            go = false;
          }
        } else {
          go = false;
        }
      })
      .then(async (value) => {
        if (go && curServ && curServ !== "" && curServ !== "other") {
          await listServices(false).then((data) => {
            const services = general.getService(curServ);
            if (services && services.length > 0) {
              if (services[0].info_req === true) {
                go = false;
              } else {
                num = 4;
              }
              general.setChosenService(services[0]);
            }
          });
        } else {
          go = false;
        }
      })
      .then(async (value) => {
        if (go && curAdd && curAdd !== "") {
          await listServices(true).then((data) => {
            if (curAdd.includes(",")) {
              curAdd.split(",").forEach((add) => {
                const addon = general.getAddon(add);
                if (addon) {
                  general.setChosenAddons(addon);
                  num = 5;
                }
              });
            } else {
              const addon = general.getAddon(curAdd);
              if (addon) {
                general.setChosenAddons(addon);
                num = 5;
              }
            }
          });
        } else {
          go = false;
        }
      })
      .then(async (value) => {
        if (go && curDate && curDate !== "" && curDate.includes("T")) {
          await listAvailableDays().then(async (resp) => {
            let data = JSON.parse(resp.data);
            if (data.availableDates) {
              let events = [];
              let date = curDate.split("T")[0];
              let time = curDate.split("T")[1];
              const selectedDate = data.availableDates.find((d) => d.date.includes(date));
              if (selectedDate) {
                listener.timeListener(curDate);
                num = 6;
              }
            } else {
              go = false;
            }
          });
        } else {
          go = false;
        }
      })
      .then((value) => {
        general.setCurrentPage(num);
        document.dispatchEvent(new Event("pageChange"));
      });
  } else {
    general.setCurrentPage(num);
    document.dispatchEvent(new Event("pageChange"));
  }
});
